export default class LongConverter {
  toQuery(defaultInfo, { fieldDetail }) {
    const valueOfFilter = fieldDetail.valueOfFilter
      ? JSON.parse(fieldDetail.valueOfFilter)
      : { type: 'auto', valueSplit: 10 };
    if (!valueOfFilter.type || valueOfFilter.type === 'auto') {
      const value = [];
      const { valueSplit } = valueOfFilter;
      for (let i = 0; i < 5; i++) {
        const val = { fromEq: '=' };
        val.from = i * valueSplit;
        if (i !== 4) {
          val.to = (i + 1) * valueSplit;
        }
        value.push(val);
      }
      return {
        ...defaultInfo,
        agg_type: 'range',
        field_type: 'num',
        value
      };
    }
    if (valueOfFilter.type === 'noRange') {
      return {
        ...defaultInfo,
        agg_type: 'term',
        field_type: 'num'
      };
    }

    if (valueOfFilter.type === 'custom') {
      const fromEq = valueOfFilter.fromEq || valueOfFilter.fromEq === undefined ? '=' : '';
      const toEq = valueOfFilter.toEq ? '=' : '';
      return {
        ...defaultInfo,
        agg_type: 'range',
        field_type: 'num',
        value: (valueOfFilter.valueArr || []).map(valItem => {
          const valObj = {};
          if (valItem[0] || valItem[0] === 0) {
            valObj.from = valItem[0];
          }
          if (valItem[1] || valItem[1] === 0) {
            valObj.to = valItem[1];
          }
          if (fromEq) {
            valObj.fromEq = fromEq;
          }
          if (toEq) {
            valObj.toEq = toEq;
          }
          return valObj;
        })
      };
    }
  }

  toFrontEndVal({ fieldItem }) {
    const defaultVal = {
      type: 'auto',
      valueArr: [],
      valueSplit: 10
    };
    if (fieldItem.agg_type === 'range') {
      defaultVal.type = 'custom';
      (fieldItem.value || []).forEach(valItem => {
        const arrItem = [];
        if (valItem.from) {
          arrItem[0] = valItem.from;
        }
        if (valItem.to) {
          arrItem[1] = valItem.to;
        }
        if (arrItem[0] || arrItem[1]) {
          defaultVal.valueArr.push(arrItem);
        }
      });
    } else {
      defaultVal.valueSplit = fieldItem.value || 10;
    }
    return JSON.stringify(defaultVal);
  }
}
